module.exports = __webpack_public_path__ + "static/media/reachedTop100_180_270.0b8702e5.png";